// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_e40dfaf1","itemsWrapper":"_c6143f7"};